import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import './OrderDetails.css';

function OrderDetails() {
  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [orderType, setOrderType] = useState('individual');
  const [groupSize, setGroupSize] = useState('');
  const [familySize, setFamilySize] = useState('');
  const [totalPrice, setTotalPrice] = useState(0);
  const [offer, setOffer] = useState('');
  const [offerItems, setOfferItems] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const { mobileNumber } = location.state || {};

  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await axios.get('http://localhost:5002/api/order/products', {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      setProducts(res.data);
    } catch (err) {
      console.error('Fetch Products Error:', err);
      alert('Error fetching products. Please try again.');
    }
  };

  const handleProductSelect = (productId, quantity) => {
    const existingProduct = selectedProducts.find(p => p.productId === productId);
    if (existingProduct) {
      if (quantity > 0) {
        setSelectedProducts(
          selectedProducts.map(p =>
            p.productId === productId ? { ...p, quantity: parseInt(quantity) } : p
          )
        );
      } else {
        setSelectedProducts(selectedProducts.filter(p => p.productId !== productId));
      }
    } else if (quantity > 0) {
      setSelectedProducts([...selectedProducts, { productId, quantity: parseInt(quantity) }]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedProducts.length === 0) {
      alert('Please select at least one product.');
      return;
    }
    if (orderType !== 'individual' && !groupSize && !familySize) {
      alert('Please specify group or family size.');
      return;
    }
    if (!mobileNumber) {
      alert('Mobile number is missing.');
      return;
    }

    console.log('Mobile Number:', mobileNumber);

    try {
      // Step 1: Calculate price
      const calcResponse = await axios.post('http://localhost:5002/api/order/calculate-price', {
        cart: selectedProducts,
        orderType,
        groupSize: orderType === 'group' ? groupSize : null,
        familySize: orderType === 'family' ? familySize : null,
        mobileNumber,
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      const { totalPrice, offer, offerItems } = calcResponse.data;
      setTotalPrice(totalPrice);
      setOffer(offer);
      setOfferItems(offerItems || []);

      // Step 2: Place the order
      const orderData = {
        customer_number: mobileNumber,
        products: selectedProducts.map(p => ({
          productId: p.productId,
          name: products.find(prod => prod.id === p.productId)?.name,
          price: products.find(prod => prod.id === p.productId)?.price,
          quantity: p.quantity,
        })),
        order_type: orderType,
        group_size: orderType === 'group' ? parseInt(groupSize) : null,
        family_size: orderType === 'family' ? parseInt(familySize) : null,
        total_price: totalPrice,
        offer_name: offer,
      };

      console.log('Placing order with data:', orderData);

      const placeResponse = await axios.post('http://localhost:5002/api/order/place', orderData, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (placeResponse.status === 200) {
        alert(`Order placed successfully!\nTotal Price: ₹${totalPrice}\nOffer: ${offer}`);
        navigate('/spin-wheel', { state: { offerItems, mobileNumber } });
      } else {
        throw new Error('Failed to place order');
      }
    } catch (err) {
      console.error('Order Error:', err.response || err);
      alert(err.response?.data?.error || 'Error placing order.');
    }
  };

  return (
    <div className="order-details-container">
      <h2>Place Your Order</h2>
      <form onSubmit={handleSubmit}>
        <div className="products-list">
          <h3>Select Products</h3>
          {products.map(product => (
            <div key={product.id} className="product-item">
              <img src={product.image} alt={product.name} className="product-image" />
              <div className="product-info">
                <span>{product.name}</span>
                <span>₹{product.price}</span>
              </div>
              <input
                type="number"
                min="0"
                placeholder="Quantity"
                onChange={(e) => handleProductSelect(product.id, e.target.value)}
              />
            </div>
          ))}
        </div>

        <div className="order-type-section">
          <h3>Order Type</h3>
          <select value={orderType} onChange={(e) => setOrderType(e.target.value)}>
            <option value="individual">Individual</option>
            <option value="group">Group</option>
            <option value="family">Family</option>
          </select>

          {orderType === 'group' && (
            <input
              type="number"
              placeholder="Group Size"
              value={groupSize}
              onChange={(e) => setGroupSize(e.target.value)}
              min="1"
            />
          )}

          {orderType === 'family' && (
            <input
              type="number"
              placeholder="Family Size"
              value={familySize}
              onChange={(e) => setFamilySize(e.target.value)}
              min="1"
            />
          )}
        </div>

        <button type="submit">Submit Order</button>
      </form>
    </div>
  );
}

export default OrderDetails;